import React from "react";
import PropTypes from "prop-types";

import { Row, Col, Table, Button, Popconfirm, Divider } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { Form, Select, Input } from "formik-antd";

import { isNotValid, translateSymfonyErrorToFormik } from "../../../core/utils/form";

/* Form & Form Validation */
import * as Yup from "yup";

import ModalForm from "../../../core/components/form/modalForm";

const validationSchema = Yup.object().shape({
    name: Yup.string().required("Cannot be blank."),
});

const propTypes = {
    item: PropTypes.object,
    currentFolder: PropTypes.string.isRequired,

    onCreateFolder: PropTypes.func.isRequired,
    onRenameFolder: PropTypes.func.isRequired,
    onRenameFile: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

const defaultProps = {
    item: null,
};

const FolderName = (props) => {
    if (props.visible == false) {
        return null;
    }

    const initialForm = () => {
        if (props.item) {
            return { name: props.item?.name };
        }
        return { name: "" };
    };

    const onCreateFolderSubmit = (values) => {
        const form = {
            action: "CREATE_FOLDER",
            name: values?.name,
            location: props.currentFolder,
        };

        return props.onCreateFolder(form);
    };

    const onRenameFolderSubmit = (values) => {
        return props.onRenameFolder(props.currentFolder, props.item.name, props.item.fullname, values.name);
    };

    const onRenameFileSubmit = (values) => {
        return props.onRenameFile(props.currentFolder, props.item.name, props.item.fullname, values.name);
    };

    const onSubmit = (values, bag) => {
        let ret = null;

        if (props?.item?.type === "folder") {
            ret = onRenameFolderSubmit(values);
        } else if (props?.item?.type === "file") {
            ret = onRenameFileSubmit(values);
        } else {
            ret = onCreateFolderSubmit(values);
        }

        if (ret) {
            ret.then((response) => {
                bag.setSubmitting(false);
                if (isNotValid(response)) {
                    bag.setErrors(translateSymfonyErrorToFormik(response.errors.children));
                } else {
                    props.onCancel();
                }
            }).catch((e) => {});
        } else {
            bag.setSubmitting(false);
        }
    };

    return (
        <ModalForm
            title={props.item ? "Rename" : "New Folder"}
            enableReinitialize={true}
            initialValues={initialForm()}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            onCancel={props.onCancel}
            visible={props.visible}
            render={({ isSubmitting, touched, errors, values, setFieldValue, setFieldTouched }) => (
                <>
                    <Form.Item label="Name" name="name">
                        <Input name="name" placeholder="Name" />
                    </Form.Item>
                </>
            )}
        />
    );
};

FolderName.propTypes = propTypes;
FolderName.defaultProps = defaultProps;

export default FolderName;
